export default {
  default(h, conf, key) {
    return conf.bpmSlot[key]
  }
}
